import "../../styles/ClaimHeader.scss";

const ClaimHeader = (props) => {
    const { claimText } = props;
    return (
        <div className="claim-header">
            <div className="claim-header-text">{claimText}</div>
        </div>
    )
};

export default ClaimHeader;